namespace $ {
	export function $giper_baza_log( this: $ ) {
		return this.$mol_state_arg.value( 'giper_baza_log' ) !== null
	}
}
